import React from 'react';
import styles from './WrappingContainer.module.css';
const WrappingContainer = ({ children, none, noScroll, className }) => {
  return (
    <div
      className={`${styles['wrapping-container']} ${className}`}
      style={{
        padding: none ? '0px' : '',
        overflowY: noScroll ? '' : 'scroll',
        height: noScroll ? 'auto' : '90vh',
      }}
    >
      {children}
    </div>
  );
};

export default WrappingContainer;
